import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs/Observable';
import { retry, map, catchError } from 'rxjs/operators';
import 'rxjs/add/observable/throw';
import { AuthService } from 'app/shared/auth/auth.service';
import { environment } from 'environments/environment';
import { GlobalService } from 'app/shared/global.service';

@Injectable()
export class ExportService {
    constructor(private http: HttpClient, private authService: AuthService, private globalService: GlobalService) { }

    export(language: string, groups: any[], roles: any[]): Observable<any> {
        return this.http
            .post(`${environment.apiUrl}/v${environment.apiVersion}/exports/init`, {
                language,
                groups,
                roles,
            }, { headers: this.authService.headers() })
            .pipe(map(data => data), catchError(this.errorHandler));
    }

    exportParents(language: string, groups: any[]): Observable<any> {
        return this.http
            .post(`${environment.apiUrl}/v${environment.apiVersion}/exports/parents`, {
                language,
                groups,
            }, { headers: this.authService.headers() })
            .pipe(map(data => data), catchError(this.errorHandler));
    }

    private errorHandler(error: Error | any): Observable<any> {
        // this.globalService.handleError(error);
        console.error('handleError', error)
        return Observable.throw(error);
    }
}



// WEBPACK FOOTER //
// ./src/app/settings/exports/shared/export.service.ts